<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: 'service-list', params: {save: true}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        <strong>{{ caption }}</strong> 服务
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="服务名" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name" required />
        </b-form-group>
        <b-form-group label="代号" label-for="code">
          <b-form-input id="code" type="text" v-model="data.code" required :disabled="isUpdate" />
        </b-form-group>
        <b-form-group label="创建实例方式" label-for="type">
          <b-form-select
              id="type" v-model="data.type"
              :options="service_types"
              required
          />
        </b-form-group>
        <b-form-group label="服务分类" label-for="category">
          <b-form-select
              id="category" v-model="data.category"
              :options="category_types"
              required
          />
        </b-form-group>
        <b-form-group label="联系人" label-for="admin_id">
          <el-select multiple class="mb-2" filterable id="service_code" v-model="data.admin_id" style="width:100%">
            <el-option v-for="admin in admins" :key="admin.value" :label="admin.text" :value="admin.value" />
          </el-select>
        </b-form-group>
        <b-form-group label="文档URL" label-for="doc_url">
          <b-form-input id="doc_url" type="text" v-model="data.doc_url" required />
        </b-form-group>
        <b-form-group label="服务URL" label-for="index_url">
          <b-form-input id="index_url" type="text" v-model="data.index_url" required />
        </b-form-group>
        <b-form-group label="创建实例接口URL" label-for="index_url">
          <b-form-input id="index_url" type="text" v-model="data.create_url" :required="data.type === 'auto'" />
        </b-form-group>
        <b-form-group label="简介" label-for="brief">
          <b-form-textarea id="brief" rows="3" v-model="data.brief" required />
        </b-form-group>
        <b-form-group label="图片" label-for="img_url">
          <image-upload id="img_url" :fileObj.sync="data.img_url" />
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-secondary"><i class="fa fa-remove" /> 返回</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import utils from '@/utils/utils'
import ImageUpload from '@/components/ImageUpload'

export default {
  name: 'service-create',
  mixins: [Error],
  components: {
    ImageUpload
  },
  data () {
    return {
      data: {
        name: '',
        code: '',
        type: null,
        category: null,
        brief: '',
        admin_id: [],
        img_url: '',
        doc_url: '',
        index_url: '',
        create_url: '',
        update_url: '',
        app_confs: {interfaces: {create: {address: ''}}}
      },
      admins: [],
      service_types: consts.SERVICE_TYPES,
      category_types: consts.CATEGORY_TYPES
    }
  },
  computed: {
    // eslint-disable-next-line
    isUpdate: function () { return !!this.$route.params.serviceCode },
    caption: function () { return this.isUpdate ? '更新' : '创建' },
    noticeUrl: {
      get: function () {
        if (utils.isUndefined(this.data.app_confs) ||
          utils.isUndefined(this.data.app_confs.interfaces) ||
          utils.isUndefined(this.data.app_confs.interfaces.create)) {
          return ''
        }
        return this.data.app_confs.interfaces.create.address
      },
      set: function (value) {
        this.data.app_confs.interfaces.create.address = value
      }
    }
  },
  created () {
    if (this.isUpdate) {
      this.fetchData()
    } else {
      this.$ajax.get(api.getAdminList()).then((adminRes) => {
        adminRes.admin_info.forEach((admin) => {
          this.admins.push({value: admin._id, text: admin.name})
        })
      }, (res) => {
        this.handleError(res)
      })
    }
  },
  methods: {
    fetchData () {
      this.$ajax.all([
        this.$ajax.get(api.getServiceUpdate(this.$route.params.serviceCode)),
        this.$ajax.get(api.getAdminList())
      ]).then(([serviceRes, adminRes]) => {
        this.$set(this, 'data', serviceRes.service_info)
        adminRes.admin_info.forEach((admin) => {
          this.admins.push({value: admin._id, text: admin.name})
        })
      }, (res) => {
        this.handleError(res)
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      if (!this.data.admin_id.length) {
        this.$message.warning('联系人不能为空')
        return
      }
      if (this.isUpdate) {
        api.updateData(this, api.getServiceUpdate(
          this.$route.params.serviceCode
        ), this.data)
      } else {
        api.createData(this, api.getServiceCreate(), this.data, 'service-list')
      }
    },
    onReset (evt) {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ServiceCreate.vue?0c28561f